// The backend stores a simulated conversation as a single flat string:
//   "agent: Hello…, user: Hi I'd like…, agent: Sure…"
// (role: message segments joined by ", "). This parses that back into ordered
// turns so the UI can render a readable, separated conversation.
//
// Splitting on a plain ", " is unsafe because messages themselves contain
// commas. Instead we anchor on the role markers ("agent:" / "user:"), which are
// the only stable delimiters, and treat everything up to the next marker as the
// message body.

const ROLE_MARKER = /(?:^|,\s*)(agent|user|assistant|system)\s*:\s*/gi;

const ROLE_LABELS = {
  agent: "Agent",
  assistant: "Agent",
  user: "Caller",
  system: "System",
};

export function roleLabel(role) {
  return ROLE_LABELS[(role || "").toLowerCase()] || role || "—";
}

export function parseTranscript(transcript) {
  if (!transcript || typeof transcript !== "string") return [];

  const markers = [];
  let m;
  ROLE_MARKER.lastIndex = 0;
  while ((m = ROLE_MARKER.exec(transcript)) !== null) {
    markers.push({
      role: m[1].toLowerCase(),
      // start of the marker itself (so the next turn can slice up to here)
      markerStart: m.index,
      // start of the message body, just after "role: "
      bodyStart: ROLE_MARKER.lastIndex,
    });
  }

  // No recognizable role markers — show the raw text as a single block rather
  // than dropping it.
  if (markers.length === 0) {
    const text = transcript.trim();
    return text ? [{ role: "unknown", message: text }] : [];
  }

  const turns = [];
  for (let i = 0; i < markers.length; i++) {
    const cur = markers[i];
    const next = markers[i + 1];
    const message = transcript
      .slice(cur.bodyStart, next ? next.markerStart : undefined)
      .trim();
    if (message) turns.push({ role: cur.role, message });
  }
  return turns;
}
